import { Controller } from "@hotwired/stimulus"
import { showMyTourDisabledNotice } from "../lib/my_tour_disabled_notice"

export default class extends Controller {
  static values = {
    id: Number,
    added: Boolean,
    guest: Boolean,
    storageKey: String,
    addLabel: String,
    addedLabel: String
  }

  connect() {
    this.syncTourState = (event) => {
      if (event.detail.projectId !== this.idValue || event.detail.added === this.addedValue) return
      this.addedValue = event.detail.added
      this.updateUI()
    }
    window.addEventListener("tour-project:changed", this.syncTourState)
  }

  disconnect() {
    window.removeEventListener("tour-project:changed", this.syncTourState)
  }

  toggle(event) {
    if (document.body.dataset.developmentFeaturesEnabled !== "true") {
      showMyTourDisabledNotice(event)
      return
    }

    event.preventDefault()
    event.stopPropagation()

    const wasAdded = this.addedValue
    this.addedValue = !wasAdded
    this.updateUI()

    fetch(`/tour_projects/${this.idValue}`, {
      method: wasAdded ? "DELETE" : "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "error" || data.status === "disabled") {
          this.addedValue = wasAdded
          this.updateUI()
        }
      })
      .catch(() => {
        this.addedValue = wasAdded
        this.updateUI()
      })
  }

  updateUI() {
    const button = this.element.matches("button") ? this.element : this.element.querySelector("button")
    if (!button) return

    const label = button.querySelector("[data-tour-project-label]")
    const text = this.addedValue
      ? (this.hasAddedLabelValue ? this.addedLabelValue : "Added to My Tour")
      : (this.hasAddLabelValue ? this.addLabelValue : "Add to My Tour")
    if (label) label.textContent = text
    button.setAttribute("aria-label", text)
    button.title = text
    if (button.dataset.tourProjectSolid === "true") {
      button.classList.toggle("bg-primary-600", this.addedValue)
      button.classList.toggle("bg-slate-900", !this.addedValue)
    }
    window.dispatchEvent(new CustomEvent("tour-project:changed", {
      detail: { projectId: this.idValue, added: this.addedValue }
    }))
  }
}
